module.exports = __webpack_public_path__ + "static/power-down-35b54274d0026a37650eb716c7a9dfe3.jpg";